import { $monitoring } from "..";

export function useMonitoringService() {
  return $monitoring;
}
